export function yearBrackets(
  yearFrom: String | undefined,
  yearTo: String | undefined
) {
  if (yearFrom && yearTo) {
    return ` (${yearFrom} - ${yearTo})`;
  } else if (yearFrom) {
    return ` (od ${yearFrom})`;
  } else if (yearTo) {
    return ` (do ${yearTo})`;
  } else {
    return "";
  }
}
